function backgroundCSS(rgbColor) {
    return 'background-color: ' + rgbCSS(rgbColor);
}

function hslCSS(color) {
    return 'hsl(' + color.hue + ', ' + color.saturation + '%, ' + color.lightness + '%)';
}

function rgbCSS(color) {
    return 'rgb(' + color.red + ', ' + color.green + ', ' + color.blue + ')';
}

export { backgroundCSS, hslCSS, rgbCSS };